import React from 'react';

const PhoneSVG = ({ width, height, fill, style }) => {
	const viewBoxValues = "0 0 120 95.2";

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.52 14.65" width={width} height={height} fill={fill}>
            <path class="cls-1" d="M9.52,1.53a.53.53,0,0,0,0-.13A1.38,1.38,0,0,0,8.8.21,3,3,0,0,0,8.25,0h-7a2.34,2.34,0,0,0-.4.13A1.47,1.47,0,0,0,0,1.56V13.08a1.27,1.27,0,0,0,0,.2,1.44,1.44,0,0,0,1.18,1.33,2,2,0,0,0,.35,0H8a1.5,1.5,0,0,0,1.54-1.54ZM5.16,13.18h-.4a4.36,4.36,0,0,1-.51,0,.71.71,0,0,1-.58-.77.78.78,0,0,1,.69-.67h.79a.72.72,0,0,1,.7.73A.68.68,0,0,1,5.16,13.18ZM8,10.24H1.47V1.47H8Z"/>
        </svg>
	);
}

export default PhoneSVG;


// WEBPACK FOOTER //
// ./src/components/common/svgs/PhoneSVG.js